import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { Variables, FilterVehiclesResponse, makeFilterVehicle } from "./types"

export const filterVehicles = createRequest<Readonly<{ variables: Variables }>, FilterVehiclesResponse>(
  async (input, getToken) => {
    const result = await platform(getToken).vehicles.filterVehicles({
      include: `make,model,trimLevel,fuelType,nominalStartYear,type,abiCode,abiGroup,numberOfSeats,grossWeight`,
      fuelType: input.variables.fuelType ?? undefined,
      model: input.variables.model ?? undefined,
      make: input.variables.make ?? undefined,
    })

    return {
      manufacturers: result.makes,
      models: result.models,
      fuelTypes: result.fuelTypes,
      vehicles: result.vehicles.map((x) =>
        makeFilterVehicle({
          nominalStartYear: x.nominalStartYear ?? null,
          trim: x.trimLevel ?? null,
          fuelType: x.fuelType ?? null,
          model: x.model ?? null,
          make: x.make ?? null,
          id: x.id,
          type: x.type ?? null,
          abiCode: x.abiCode ?? null,
          abiGroup: x.abiGroup ?? null,
          numberOfSeats: x.numberOfSeats ?? null,
          grossWeight: x.grossWeight ?? null,
        })
      ),
    }
  }
)

export const useFilterVehicles = createRequestHook(filterVehicles)
